import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AApplicationRestClient } from "../a-application-rest.client";
import { IWidgetRestClient } from "./i-widget-rest.client";

@Injectable()
export class WidgetRestClient extends AApplicationRestClient implements IWidgetRestClient {
  constructor(httpClient: HttpClient) {
    super( httpClient, 'widget' );
  }
}
